import { Button, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  round: number;
  onOpenHistory: () => void;
}

export function InquiryPriceRoundButton({ round, onOpenHistory }: Props) {
  const { t } = useTranslation();
  const label = t('inquiry.priceRound', { round });

  return (
    <Tooltip label={label}>
      <Button
        aria-label={label}
        variant="texas-light"
        size="xs"
        h={4}
        minW={4}
        px={1}
        borderRadius="sm"
        fontSize="2xs"
        lineHeight={1}
        flexShrink={0}
        onClick={(event) => {
          event.stopPropagation();
          onOpenHistory();
        }}
      >
        {round}
      </Button>
    </Tooltip>
  );
}
